export function cn(...classes: (string | boolean | undefined)[]) {
  return classes.filter(Boolean).join(" ");
}

const ENV = {
  PRODUCTION: "production",
  STAGING: "staging",
  DEVELOPMENT: "development",
};

/**
 * APP_ENV cast to string to allow custom environment values like "staging".
 * Can be used server-side and client-side.
 */
export const getAppEnv = () => {
  // First, attempt to get server-side env var.
  // If it is not set then there is a chance that the caller is client-side.
  return process.env.APP_ENV || process.env.NEXT_PUBLIC_APP_ENV;
};

/** True when running in production (APP_ENV === "production"). */
export const isProduction = (): boolean => {
  if (process.env.NODE_ENV === "production" && !getAppEnv()) {
    console.warn("⚠️ NODE_ENV is production but APP_ENV is not set!");
  }
  return getAppEnv() === ENV.PRODUCTION;
};

/** True when running in staging (APP_ENV === "staging"). */
export const isStaging = (): boolean => {
  return getAppEnv() === ENV.STAGING;
};

/** True when running in development (APP_ENV === "development"). */
export const isDevelopment = (): boolean => {
  return getAppEnv() === ENV.DEVELOPMENT;
};

/** True when running in a deployed environment (production or staging). */
export const isDeployedEnvironment = (): boolean => {
  return isProduction() || isStaging();
};

export const getBaseUrl = (): string => {
  if (isDevelopment()) {
    return "http://localhost:3000";
  }
  // porter injects this environment variable to give us the base URL of the app
  return (
    process.env.PORTER_DOMAINS?.split(",")[0].trim() ||
    "https://app.getsymphony.co"
  );
};
